<style lang="scss" scoped>
.workshopHourOuput::-webkit-scrollbar {
  display: none;
}

.grid {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  padding: 6px 0;

  &:not(:last-child) {
    margin-right: 10px;
  }
}
</style>
<style lang="scss" scoped>
.weier-prodcution-monitor-border {

  border: 1px solid;
  border-image: url("../../../../../../assets/img/web/weier/production/xiankuang2.png") 10 stretch;
}
</style>

<template>
  <div class="workshopHourOuput" ref="container" style="overflow: auto;height: 100%;position: relative;display: flex;flex-direction: column;">

    <div ref="titleBar" class="titleBar" style="display: flex;align-items:center ;padding-bottom: 0px;box-sizing: border-box;">
      <img style="width: auto;height: 42px;" src="../../../../../../assets/img/web/weier/production/sbjk.png" />
    </div>
    <div class="weier-prodcution-monitor-border" style="flex:1;display: flex;flex-direction: column;justify-content: space-around;padding:0 20px;">

      <div style="display: flex;justify-content: space-between;align-items: center;">

        <div v-for="i in [{ key: 'total', name: '总数' }, { key: 'fenge' }, { key: '0', name: '生产' }, { key: 'fenge' }, { key: '1', name: '转产' }, { key: 'fenge' }, { key: '-1', name: '待排' }, { key: 'fenge' }, { key: '3', name: '故障' }]">
          <div style="text-align: center;" v-if="i.key != 'fenge'">
            <p style=" font-size: 18px;color:rgba(226, 99, 255, 1);font-weight: bold;">{{ status[i.key] }}</p>
            <p style="font-size: 14px;color:white;margin-top: 8px;">{{ i.name }}</p>
          </div>
          <div v-else style="width: 2px;height:24px;background-color:rgba(100, 214, 248, 0.3);"></div>
        </div>

      </div>

    </div>

  </div>
</template>
<script type="text/javascript">
export default {
  name: "web_customize_weier_monitor_production_shebeijiankong",
  components: {},
  props: {
    datas: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      status: {
        "total": 0,
        "-1": 0,
        "0": 0,
        "1": 0,
        "3": 0,
      },
      timmer: null,
    };
  },
  watch: {
    "datas"(newValue, oldValue) {
      if (this.utils.isEqual(newValue, oldValue)) {
        return;
      }
      this.status = {
        "total": 0,
        "-1": 0,
        "0": 0,
        "1": 0,
        "3": 0,
      }
      for (let index = 0; index < newValue.length; index++) {
        const eq = newValue[index];
        this.status[eq.status + ""] = this.status[eq.status + ""] + 1;
        this.status.total = this.status.total + 1;
      }
    },
  },

  created() {
    this.timmer = setInterval(() => {
    }, 120000);
  },
  activated() {
    this.resize();
  },
  mounted() {
    setTimeout(() => {
      this.resize();
    }, 700);
    this.resize();
    this.utils.event_hub.$on("RESIZE", () => {
      this.resize();
    });
  },
  destroyed() {
    clearInterval(this.timmer);
  },
  methods: {

    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {

      }, 800);
    },

  },
};
</script>
